import { getQuery, updateQuery, deleteQuery, insertQuery } from "api/UdasWrapper";
import { addErrorLog } from "../Logger/logger";
import { uploadFileQuery } from "./UdasWrapper";

export const getComponents = async (tenant_id) => {
  try {
    const data = JSON.stringify({
      query: `query Query($tenantId: String!) {
        cxfComponents(tenant_id: $tenantId) {
          id
          created_date_time
          name
          description
          config_files
          parent_component_id
          user_name
          version
          status
          scope
          tenant_id
          price
          tags
          logo
          component_type
          publish_status
          publish_date_time
          comments
          support
          developer
          developer_logo
          updated_date_time
          documentation
          created_by_id
          schema
        }
      }`,
      variables: {
        tenantId: tenant_id
      }
    });
    const response = await getQuery(data);
    return response?.cxfComponents;
  } catch (error) {
    addErrorLog("query CxfComponents", error, tenant_id);
    return null;
  }
};

export const getCheckConnectorsUsage = async (tenant_id, component_id) => {
  const data = JSON.stringify({
    query: `query CheckConnectorsUsage($componentId: String!, $tenantId: String!) {
      checkConnectorsUsage(component_id: $componentId, tenant_id: $tenantId) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      componentId: component_id
    }
  });
  try {
    const response = await getQuery(data);
    return response?.checkConnectorsUsage;
  } catch (error) {
    addErrorLog("query CheckConnectorUsage", error, tenant_id);
    return null;
  }
};

export const deleteComponent = async (tenant_id, component_id) => {
  const data = JSON.stringify({
    query: `mutation DeleteCxfComponents($tenantId: String!, $deleteCxfComponentsId: String!) {
      deleteCxfComponents(tenant_id: $tenantId, id: $deleteCxfComponentsId) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      deleteCxfComponentsId: component_id
    }
  });
  try {
    const response = await deleteQuery(data);
    return response?.deleteCxfComponents;
  } catch (error) {
    addErrorLog("mutation DeleteCxfComponents", error, tenant_id);
    return null;
  }
};

export const uploadConnectorZipFile = async (file, tenant_id, componentKey, version) => {
  const formData = new FormData();
  const query = `mutation UploadConnectorZipFile($file: Upload!, $tenant_id: String!, $componentKey: String!, $version: String!) { 
        uploadConnectorZipFile(file: $file, tenant_id: $tenant_id, componentKey: $componentKey, version: $version) { 
        isSuccessful message resultObject 
        } 
      }`;
  formData.append(
    "operations",
    JSON.stringify({
      query,
      variables: {
        file: null,
        tenant_id,
        componentKey,
        version
      }
    })
  );

  let mapData = { 0: ["variables.file"] };

  formData.append("map", JSON.stringify(mapData));
  formData.append("0", file);

  const uploadResponse = await uploadFileQuery(formData);

  return uploadResponse?.uploadConnectorZipFile;
};

export const extractConnectorZipFileInformation = async (file) => {
  try {
    const formData = new FormData();
    const query = `mutation ExtractConnectorZipFileInformation($file: Upload!) { 
          extractConnectorZipFileInformation(file: $file) { 
          isSuccessful message resultObject 
          } 
        }`;
    formData.append(
      "operations",
      JSON.stringify({
        query,
        variables: {
          file: null
        }
      })
    );

    let mapData = { 0: ["variables.file"] };

    formData.append("map", JSON.stringify(mapData));
    formData.append("0", file);

    const uploadResponse = await uploadFileQuery(formData);

    return uploadResponse?.extractConnectorZipFileInformation;
  } catch (error) {
    addErrorLog("mutation extractConnectorZipFileInformation", error);
    return null;
  }
};

export const insertSharedConnectors = async (tenant_id, input) => {
  try {
    const data = JSON.stringify({
      query: `mutation InsertSharedConnectors($tenant_id: String!, $input: [SharedConnectorsInput]) {
  insertSharedConnectors(tenant_id: $tenant_id, input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { tenant_id, input }
    });
    const result = await insertQuery(data);

    return result?.insertSharedConnectors;
  } catch (error) {
    addErrorLog("mutation InsertSharedConnectors", error);
    return null;
  }
};

export const deleteSharedConnectors = async (tenant_id, input) => {
  try {
    const data = JSON.stringify({
      query: `mutation DeleteSharedConnectors($tenant_id: String!, $input: [ID]) {
  deleteSharedConnectors(tenant_id: $tenant_id, input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { tenant_id, input }
    });
    const result = await deleteQuery(data);

    return result?.deleteSharedConnectors;
  } catch (error) {
    addErrorLog("mutation DeleteSharedConnectors", error);
    return null;
  }
};

export const getSharedConnectors = async (tenant_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetSharedConnectors($tenant_id: String!) {
  getSharedConnectors(tenant_id: $tenant_id) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { tenant_id }
    });
    const result = await getQuery(data);

    return result?.getSharedConnectors;
  } catch (error) {
    addErrorLog("query GetSharedConnectors", error);
    return null;
  }
};

export const updateSharedConnector = async (input) => {
  try {
    const data = JSON.stringify({
      query: `mutation UpdateSharedConnector($input: UpdateSharedConnectorsInput) {
        updateSharedConnector(input: $input) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: { input }
    });
    return (await updateQuery(data))?.updateSharedConnector;
  } catch (error) {
    addErrorLog("mutation updateSharedConnector", error);
    return null;
  }
};
